const formatPreValidationForClevertap = validations => {
  const result = {};
  Object.keys(validations).forEach(validation => {
    result[validation] = validations[validation].map(errorObject => errorObject.failureCode).join(',');
  });
  console.log(result);
  return result;
};
export default formatPreValidationForClevertap;
